export const layoutLocale = {
    en: {
        common: {
            successConnection: "Connection successful",
            rejectedKycTitle: "Your account has been denied authentication",
            approvedKycTitle: "Your account has been verified",
            rejectedKycSubTitle: "You need to re-authenticate to buy NFT",
            email: 'Email',
            password: 'Password',
            login: 'Login',
            home: 'Market',
            collection: 'My Collection',
            nft_intro: 'NFT Intro',
            faq: 'faq',
            about_us: 'About Us',
            userName: 'User name',
            menuHomePage: 'Market',
            menuCollection: 'Collection',
            menuFAQ: 'FAQ',
            menuTermsOfUse: 'Terms of use',
            menuPolicy: 'Privacy policy',
            copyRight: '© 2022 AIS Inc. All Rights Reserved',
            CCCDrequired: 'Citizen ID number cannot be left blank',
            nationalRequired: 'Country cannot be left blank',
            minMax: '{field} must be from {min} to {max} characters',
            passportRequired: 'Passport number cannot be left blank',
            errors: {
                max: 'Please enter within {length} characters',
                required: '{field} cannot be left blank',
                passwordRegex:
                    'Password must be between 6 and 32 characters, including uppercase and lowercase letters, numbers and special characters.',
                emailRegex: 'Email invalidate',
                passwordConfirmErrorMessage: 'Password does not match',
            },
            fields: {
                password: 'Password',
                oldPassword: 'old password',
                newPassword: 'new password',
                confirmPassword: 'Enter your password',
                email: 'Email',
                userName: 'User name',
                otp: 'Verification code',
            },
            newAccountTooltip: 'Your account is nothentication',
            rejectAccountTooltip:
                'Your account is waiting for identity verification review',
            accountApprovedTooltip: 'Your account has been approved',
            accountRejectTooltip:
                'Your account has been denied identity verification. Please, verify again',
            accountPendingTooltip:
                'Your account is waiting for identity verification review',
            days: 'Days',
            hours: 'Hours',
            minutes: 'Minutes',
            seconds: 'Seconds',
        },
    },
    vi: {
        common: {
            rejectedKycTitle: "Tài khoản của bạn đã bị từ chối xác thực",
            approvedKycTitle: "Tài khoản của bạn đã được xác thực",
            rejectedKycSubTitle: "Bạn cần xác thực lại để có thể mua NFT",
            successConnection: "Kết nối thành công",
            email: 'Email',
            password: 'Password',
            login: 'Đăng Nhập',
            home: 'Chợ NFT',
            nft_intro: 'Giới thiệu về NFT',
            collection: 'Bộ sưu tập',
            about_us: 'Về chúng tôi',
            faq: 'faq',
            userName: 'Họ và tên',
            menuHomePage: 'Chợ NFT',
            menuCollection: 'Bộ sưu tập',
            termsOfUseMenu: 'Điều khoản sử dụng',
            policyMenu: 'Chính sách quyền riêng tư',
            menuFAQ: 'FAQ',
            menuTermsOfUse: 'Điều khoản sử dụng',
            menuPolicy: 'Chính sách quyền riêng tư',
            copyRight: '© 2022 Bản quyền bởi AIS Inc',
            required: 'Họ và tên không được để trống',
            CCCDrequired: ' Số căn cước công dân không được để trống',
            nationalRequired: 'Quốc gia không được để trống',
            passportRequired: 'Số hộ chiếu không được để trống',
            minMax: '{field} phải nằm trong khoảng từ {min} đến {max} ký tự',
            errors: {
                max: 'Vui lòng nhập trong khoảng {length} ký tự',
                required: '{field} không được để trống',
                passwordRegex:
                    'Mật khẩu phải từ 6 đến 32 ký tự, bao gồm chữ cái in hoa, in thường, số và ký tự đặc biệt.',
                emailRegex: 'Email không đúng định dạng',
                passwordConfirmErrorMessage: 'Mật khẩu không trùng khớp',
            },
            fields: {
                password: 'Mật khẩu',
                oldPassword: 'Mật khẩu cũ',
                newPassword: 'Mật khẩu mới',
                confirmPassword: 'Nhập lại mật khẩu',
                email: 'Email',
                userName: 'Họ và tên',
                otp: 'Mã xác minh',
            },
            newAccountTooltip: 'Tài khoản của bạn chưa xác thực',
            rejectAccountTooltip:
                'Tài khoản của bạn đang đợi xét duyệt xác thực danh tính',
            accountApprovedTooltip: 'Tài khoản của bạn đã được xét duyệt',
            accountRejectTooltip:
                'Tài khoản của bạn đã bị từ chối xác thực danh tính. Vui lòng thực hiện xác thực lại',
            accountPendingTooltip:
                'Tài khoản của bạn đang đợi xét duyệt xác thực danh tính',
            days: 'Ngày',
            hours: 'Giờ',
            minutes: 'Phút',
            seconds: 'Giây',
        },
    },
    jp: {
        common: {
            rejectedKycTitle: "あなたのアカウントは認証を拒否されました",
            approvedKycTitle: "あなたのアカウントは認証されました",
            rejectedKycSubTitle: "NFTを購入するには再認証が必要です",
            successConnection: "接続が成功しました",
            email: 'メール',
            password: 'パスワード',
            login: 'ログイン',
            home: 'ホームページ',
            nft_intro: 'NFTについて',
            collection: 'コレクション',
            about_us: '当社について',
            faq: 'faq',
            userName: '氏名',
            menuHomePage: 'ホームページ',
            menuCollection: 'コレクション',
            termsOfUseMenu: '利用規約',
            policyMenu: 'プライバシーポリシー',
            menuFAQ: 'FAQ',
            menuTermsOfUse: '利用規約',
            menuPolicy: 'プライバシーポリシー',
            copyRight: '© 2022 AIS Incによる著作権',
            required: '氏名を空白にしてはいけない',
            CCCDrequired: ' 公民証明書空白にしてはいけない',
            nationalRequired: '国を空白にしてはいけない',
            passportRequired: 'パスポートを空白にしてはいけない',
            minMax: '{field} は{min} 文字から {max} 文字までにする必要があります',
            errors: {
                max: '{length} 文字以内で入力してください',
                required: '{field} を空白にしてはいけない',
                passwordRegex:
                    'パスワードは、大文字、小文字、数字、特殊文字を含む 6 ～ 32 文字にする必要があります。',
                emailRegex: 'メールは不正な形式にしています',
                passwordConfirmErrorMessage: 'パスワードが一致しません',
            },
            fields: {
                password: 'パスワード',
                oldPassword: '旧パスワード',
                newPassword: '新パスワード',
                confirmPassword: 'パスワードを再入力',
                email: 'メール',
                userName: '氏名',
                otp: '認証コード',
            },
            newAccountTooltip: 'あなたのアカウントは認証されていません',
            rejectAccountTooltip:
                'あなたのアカウントは本人確認審査を待っています',
            accountApprovedTooltip: 'あなたのアカウントは承認されました',
            accountRejectTooltip:
                'あなたのアカウントは本人認証を拒否されました。 再認証してください',
            accountPendingTooltip:
                'あなたのアカウントは本人認証承認を待っています',
            days: '日付',
            hours: '時',
            minutes: '分',
            seconds: '秒',
        },
    },
    zh: {
       common: {
           rejectedKycTitle: "您的帐户已被拒绝验证",
           approvedKycTitle: "您的帐户已通过验证",
           rejectedKycSubTitle: "您需要重新验证才能购买NFT",
           successConnection: "连接成功",
           email: '邮箱',
           password: '密码',
           login: '登录',
           home: '主页',
           nft_intro: '关于 NFT',
           collection: '收藏',
           about_us: '关于我们',
           faq: 'faq',
           userName: '全名',
           menuHomePage: '主页',
           menuCollection: '收藏',
           termsOfUseMenu: '使用条款',
           policyMenu: '隐私政策',
           menuFAQ: 'FAQ',
           menuTermsOfUse: '使用条款',
           menuPolicy: '隐私政策',
           copyRight: '© 2022 版权所有 AIS Inc',
           required: '名字和姓氏不能为空',
           CCCDrequired: ' 公民身份证号码不能为空',
           nationalRequired: '国家不能为空',
           passportRequired: '护照号码不能为空',
           minMax: '{field} 必须介于 {min} 和 {max} 个字符之间',
           errors: {
               max: '请输入 {length} 个字符以内',
               required: '{field} 不能为空',
               passwordRegex:
                   '密码长度必须在 6 到 32 个字符之间，包括大小写字母、数字和特殊字符。',
               emailRegex: '邮箱格式不正确',
               passwordConfirmErrorMessage: '密码不匹配',
           },
           fields: {
               password: '密码',
               oldPassword: '旧密码',
               newPassword: '新密码',
               confirmPassword: '重新输入密码',
               email: '邮箱',
               userName: '全名',
               otp: '验证码',
           },
           newAccountTooltip: '您的帐户未经验证',
           rejectAccountTooltip:
               '您的帐号正在等待身份验证审核',
           accountApprovedTooltip: '您的帐户已获批准',
           accountRejectTooltip:
               '您的帐户已被拒绝身份验证。 请重新验证',
           accountPendingTooltip:
               '您的帐号正在等待身份验证审核。',
           days: '日',
           hours: '时',
           minutes: '分',
           seconds: '秒',
       }
    },
    ko: {
        common: {
            rejectedKycTitle: "거부된 타이틀",
            approvedKycTitle: "승인된 타이틀",
            rejectedKycSubTitle: "NFT를 구매하려면 재인증해야 합니다.",
            successConnection: "성공 연결",
            email: '이메일',
            password: '비밀번호',
            login: '로그인',
            home: '홈',
            nft_intro: 'NFT에 대한 정보',
            collection: '콜렉션',
            about_us: '어바웃어스',
            faq: 'faq',
            userName: '사용자 이름',
            menuHomePage: '메뉴 홈페이지',
            menuCollection: '콜렉션',
            termsOfUseMenu: '이용약관 메뉴',
            policyMenu: '개인 정보 정책 메뉴',
            menuFAQ: 'FAQ',
            menuTermsOfUse: '이용약관 메뉴',
            menuPolicy: '개인 정보 정책 메뉴',
            copyRight: '© 2022 AIS Inc의 저작권',
            required: '필수 항목',
            CCCDrequired: ' 주민등록번호는 비워 둘 수 없습니다.',
            nationalRequired: '국가는 비워둘 수 없습니다.',
            passportRequired: '여권 번호는 비워둘 수 없습니다.',
            minMax: '{field}는 {min}에서 {max}자 사이여야 합니다.',
            errors: {
                max: '{length}자 이내로 입력해주세요.',
                required: '{field}는 비워둘 수 없습니다.',
                passwordRegex:
                    '비밀번호는 영문 대소문자, 숫자, 특수문자를 포함하여 6~32자 사이여야 합니다.',
                emailRegex: '이메일 무효화',
                passwordConfirmErrorMessage: '비밀번호가 일치하지 않습니다.',
            },
            fields: {
                password: '비밀번호',
                oldPassword: '기존 비밀번호',
                newPassword: '신규 비밀번호',
                confirmPassword: '비밀번호 확인',
                email: 'Email',
                userName: '사용자 이름',
                otp: '일회용 비밀번호',
            },
            newAccountTooltip: '계정이 확인되지 않았습니다.',
            rejectAccountTooltip:
                '계정이 신원 확인 검토를 기다리고 있습니다.',
            accountApprovedTooltip: '계정이 승인되었습니다',
            accountRejectTooltip:
                '계정은 신원 확인이 거부되었습니다. 재확인 부탁드립니다.',
            accountPendingTooltip:
                '계정이 신원 확인 검토를 기다리고 있습니다.',
            days: '일',
            hours: '시간',
            minutes: '분',
            seconds: '초',
        }

    },
    ru: {
        common: {
            rejectedKycTitle: "Ваша учетная запись не прошла проверку",
            approvedKycTitle: "Ваша учетная запись проверена",
            rejectedKycSubTitle: "Вам необходимо пройти повторную проверку для покупки NFT",
            successConnection: "Успешное подключение",
            email: 'Email',
            password: 'Пароль',
            login: 'Войти',
            home: 'Главная',
            nft_intro: 'Введение в NFT',
            collection: 'Коллекция',
            about_us: 'О нас',
            faq: 'Часто задаваемые вопросы',
            userName: 'Имя',
            menuHomePage: 'Главная',
            menuCollection: 'Коллекция',
            termsOfUseMenu: 'Условия использования',
            policyMenu: 'Политика конфиденциальности',
            menuFAQ: 'Часто задаваемые вопросы',
            menuTermsOfUse: 'Условия использования',
            menuPolicy: 'Политика конфиденциальности',
            copyRight: '© 2022 Все права защищены, AIS Inc',
            required: 'Поле "Имя" не может быть пустым',
            CCCDrequired: 'Поле "Социальное страхование" не может быть пустым',
            nationalRequired: 'Поле "Страна" не может быть пустым',
            passportRequired: 'Поле "Паспорт" не может быть пустым',
            minMax: '{field} должно содержать от {min} до {max} символов',
            errors: {
                max: 'Введите не более {length} символов',
                required: 'Поле "{field}" не может быть пустым',
                passwordRegex:
                    'Пароль должен содержать от 6 до 32 символов, включая заглавные и строчные буквы, цифры и специальные символы',
                emailRegex: 'Некорректный формат email',
                passwordConfirmErrorMessage: 'Пароли не совпадают',
            },
            fields: {
                password: 'Пароль',
                oldPassword: 'Старый пароль',
                newPassword: 'Новый пароль',
                confirmPassword: 'Подтвердите пароль',
                email: 'Email',
                userName: 'Имя',
                otp: 'Код подтверждения',
            },
            newAccountTooltip: 'Ваша учетная запись не проверена',
            rejectAccountTooltip:
                'Ваша учетная запись ожидает проверки',
            accountApprovedTooltip: 'Ваша учетная запись проверена',
            accountRejectTooltip:
                'Ваша учетная запись не прошла проверку. Пожалуйста, пройдите повторную проверку',
            accountPendingTooltip:
                'Ваша учетная запись ожидает проверки',
            days: 'дни',
            hours: 'часы',
            minutes: 'минуты',
            seconds: 'секунды',
        },
    }

};
